const usePhoneInputV2Styles = ({ isCountrySearchEnabled }: { isCountrySearchEnabled: boolean }) => {
    const errorText = {
        '.MuiCollapse-wrapperInner': {
            color: '#df1d17',
            fontFamily: 'inherit',
            fontWeight: '400',
            fontSize: '0.75rem', // 12px
            letterSpacing: '0.004em',
            'html[dir="rtl"] &': {
                textAlign: 'right',
            },
        },
    };

    const select = {
        width: 'max-content',
        left: '0px',
        '.MuiOutlinedInput-notchedOutline': { borderStyle: 'none' },
        background: 'rgb(245, 245, 245) !important',
        // Remove default outline (display only on focus)
        fieldset: {
            display: 'none',
        },
        // Update default spacing
        '.MuiSelect-select': {
            paddingRight: '24px !important',
            paddingLeft: '8px !important',
        },
        svg: {
            right: '0px',
        },
    };

    const textField = {
        width: '100%',
        '& .MuiInputBase-root': {
            borderRadius: '5px',
            height: '3rem',
            paddingLeft: '8px',
        },
        '> div > input': {
            paddingTop: '8px',
            paddingBottom: '8px',
            paddingLeft: '0px',
            textAlign: 'left',
            'html[dir="rtl"] &::placeholder': {
                textAlign: 'right',
            },
        },
    };

    const menu = {
        maxHeight: '200px',
        ' > ul': {
            paddingTop: isCountrySearchEnabled ? 0 : '8px',
        },
    };

    const flagImageStyles = {
        display: 'flex',
    };

    const countrySearch = {
        position: 'sticky',
        top: 0,
        left: 0,
        right: 0,
        backgroundColor: 'white',
        zIndex: 10,
        padding: '0 8px 6px',
    };

    const countrySearchTextField = {
        'html[dir="rtl"] &': {
            label: {
                left: 'inherit !important',
                right: '1.5rem !important',
                transformOrigin: 'right !important',
            },
            legend: {
                textAlign: 'right !important',
            },
        },
    };

    return {
        errorText,
        select,
        textField,
        menu,
        flagImageStyles,
        countrySearch,
        countrySearchTextField,
    };
};

export default usePhoneInputV2Styles;
